/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

import helper from "Resources/util/helper";

export const getByKey = (key, state) => {

    let storageKey = state.generate_key(key);

    let stateData = state[storageKey];

    let data = stateData ? stateData : localStorage.getItem(storageKey);

    // if(data && !stateData) {
    //     state[storageKey] = data;
    // }

    if (data) {
        return helper.getWithExpiry(data, storageKey);
    }

    return null;
};

export default {
    getCacheConfig: state => {
        return state.config;
    },
    generateKey: state => {
        return info => {
            return state.generate_key(info.url, info.params, state);
        };
    },
    getList: state => {
        console.log('getByKey');
        return (key) => {
            console.log('get List ', key);
            return getByKey(key, state);
        };
    },
    getNrcInfo: state => {

        const key = state.generate_key(state.keys.NRC_INFO, {}, state);

        return getByKey(key, state);
    },
    getPullingState: state => {
        return (url, params) => {
            const key = state.generate_key(url, params, state);

            return state.inPulling[key];
        };
    },
    getPromise: state => {
        return (url, params) => {
            const key = state.generate_key(url, params, state);

            return state.promise[key];
        };
    },
    getBreadCrumbs: state => {
        return state.routeHistory;
    },
    getLocale: state => {
        return state.locale;
    }
};